import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { makePostRequest } from 'utils/api'
import { Box, CircularProgress, Typography } from '@mui/material'

export default function GoogleAuth() {
  const navigate = useNavigate()
  const location = useLocation()
  const [status, setStatus] = useState('processing')

  useEffect(() => {
    const processOAuthCallback = async () => {
      try {
        console.log('GoogleAuth mounted, pathname:', location.pathname)
        console.log('Full URL:', window.location.href)
        
        const return_url = localStorage.getItem('return_url')
        
        // Check for both /oauth2callback and /oauth2callback/ (with trailing slash)
        if (location.pathname === '/oauth2callback' || location.pathname === '/oauth2callback/') {
          console.log('Processing Google OAuth callback...')
          // Google OAuth callback
          // Send the full authorization response URL to the backend
          const fullAuthUrl = window.location.href
          
          const res = await makePostRequest(
            '/api/user/oauth2callback/',
            { authorization_response: fullAuthUrl },
            {},
            true
          )
          
          console.log('Google OAuth response:', res)
          
          if (res.status === 200) {
            if (res.data.i_contacts) {
              localStorage.setItem('i_contacts', res.data.i_contacts)
              localStorage.setItem('i_contacts_added', true)
            }
            setStatus('success')
            localStorage.removeItem('return_url')
            setTimeout(() => {
              navigate(return_url || '/')
            }, 1000)
          } else {
            setStatus('error')
            setTimeout(() => {
              navigate('/')
            }, 3000)
          }
        } else if (location.pathname === '/microsoft' || location.pathname === '/microsoft/') {
          console.log('Processing Microsoft OAuth callback...')
          // Microsoft OAuth callback
          const fullAuthUrl = window.location.href
          
          const res = await makePostRequest(
            '/api/user/callback-Microsoft/',
            { authorization_response: fullAuthUrl },
            {},
            true
          )
          
          console.log('Microsoft OAuth response:', res)
          
          if (res.status === 200) {
            setStatus('success')
            localStorage.removeItem('return_url')
            setTimeout(() => {
              navigate(return_url || '/')
            }, 1000)
          } else {
            setStatus('error')
            setTimeout(() => {
              navigate('/')
            }, 3000)
          }
        } else {
          console.log('Path does not match OAuth callback routes')
        }
      } catch (error) {
        console.error('OAuth callback error:', error)
        setStatus('error')
        setTimeout(() => {
          navigate('/')
        }, 3000)
      }
    }

    processOAuthCallback()
  }, [location.pathname, location.search, navigate])

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
    >
      {status === 'processing' && (
        <>
          <CircularProgress />
          <Typography>Connexion en cours...</Typography>
        </>
      )}
      {status === 'success' && (
        <Typography color="success.main">Compte connecté avec succès!</Typography>
      )}
      {status === 'error' && (
        <Typography color="error.main">Erreur lors de la connexion</Typography>
      )}
    </Box>
  )
}
